<ui-control-field
  [label]="label()"
  [isRequired]="isRequired()"
  [error]="error()">
  <div class="control" [formGroup]="form">
    <div class="control__dropdown">
      <p-dropdown
        placeholder="Prefix"
        inputId="phonePrefix"
        formControlName="phonePrefix"
        [options]="options()"
        [disabled]="disabled()">
        <ng-template let-option pTemplate="item">
          <div class="control__dropdown-item">
            <span>{{ option.data }}</span>
            <span>{{ option.value }}</span>
          </div>
        </ng-template>

        <ng-template let-selected pTemplate="selectedItem">
          @if (selected) {
            <div class="control__dropdown-item">
              <span>{{ selected.data }}</span>
              <span>{{ selected.value }}</span>
            </div>
          }
        </ng-template>
      </p-dropdown>
    </div>

    <div class="control__input">
      <p-inputMask
        mask="999-999-999"
        formControlName="phone"
        [id]="id()"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        (onBlur)="markAsTouched()" />
    </div>
  </div>
</ui-control-field>
